<template>
  <div class="content-wrapper">
    <div class="boxLf" style="padding: 22px 0;box-sizing: border-box;padding: 22px 0 22px 25px;">
        <span style='color:#555;'>{{Cardtitle}}</span>
        <span style="font-size:20px;margin-top: 7px;height: 42px;margin-bottom: 30px;"><i :class="['font30','hbg'+avgScoreData.avgScoreLevel]">{{avgScoreData.avgScore}}</i>/{{totalScore}}(分)</span>
        <span>{{scoreMonth}}</span>
    </div>
    <div :id="mapID" v-bind:style="styleAttr" style="width:160px;float: right;"></div>
  </div>
</template>
<script>
import api from '../../com/ajax' // ajax请求封装
import config from '../../com/config' // url配置文件
export default {
  name: 'pie',
  data () {
    return {
      avgScoreData: {
        avgScore: '--',
        avgScoreLevel: ''
      },
      data: [],
      title: {
        subtext: '',
        text: '\n\n\n\n好',
        subtextStyle: {
          color: '#999',
          fontSize: 14
        },
        textStyle: {
          color: '#30B0F6',
          fontSize: 14
        },
        x: 'center'
      }
    }
  },
  props: {
    categoryId: '',
    Cardtitle: '',
    scorePolicyAreaId: '',
    scoreMonth: '',
    avgScore: 0,
    totalScore: '',
    mapID: {// 饼图渲染id
      type: String,
      default: ''
    },
    legendShow: {// 设置标注是否显示
      type: Boolean,
      default: true
    },
    legendData: {// 坐标类别值
      type: Array
    },
    seriesData: {// 饼图数据
      type: Array
    },
    colors: {// 色彩主题
      type: Array,
      default: function () {
        return ['#FD6A7C', '#F5A623 ', '#00C853', '#30B0F6']
      }
    },
    radius: {
      type: Array,
      default: function () {
        return ['70%', '90%']
      }
    },
    itemStyle: {
      type: Object,
      default: function () {
        return {
          normal: {
            // color: function (params) {
            //   return this.colors[params.dataIndex]
            // },
            label: {
              show: true,
              formatter: function (params) {
                return (params.percent - 0).toFixed(1) + '%'
              },
              color: '#333'
            },
            labelLine: {
              show: true
            },
            formatter: '{b}:{c}: ({d}%)'
          }
        }
      }
    },
    styleAttr: {// style样式
      type: Object,
      default: function () {
        return {
          height: '160px'
        }
      }
    }
  },
  methods: {
    optionFun (data, number) {
      let that = this
      let myChart = this.$echarts.init(document.getElementById(that.mapID))
      that.option = {
        title: that.title,
        // 设置参数
        series: {
          name: '访问来源',
          type: 'pie',
          radius: ['60%', '80%'],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: false,
              position: 'center'
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          data: data
        },
        color: that.colors
      }
      myChart.setOption(that.option)
      myChart.on(
        'mouseover', function (event) {
          if (event.data.name === '暂无') {
            return false
          }
          that.option.title.subtext = event.data.value + '所'
          that.option.title.text = '\n\n\n\n' + event.data.name
          that.option.title.textStyle.color = event.color
          myChart.setOption(that.option)
        }
      )
      myChart.on(
        'mouseout', function (event) {
          if (event.data.name === '暂无') {
            return false
          }
          that.option.title.subtext = number + '所'
          that.option.title.text = '\n\n\n\n好'
          that.option.title.textStyle.color = '#30B0F6'
          myChart.setOption(that.option)
        }
      )
    }
  },
  created () {
    var self = this
    if (this.avgScore === '' || this.avgScore === undefined) {
      self.color = ['#eee']
      return false
    }
    api.post(config.khsHost + 'spv/policy/hhs/getCategoryAvgScore.do', {'categoryId': self.categoryId,
      'scorePolicyAreaId': self.scorePolicyAreaId,
      'scoreMonth': self.scoreMonth}
      ).then((data) => {
        if (data.success === true) {
          self.avgScoreData = data.body
          var numData = [
            {value: data.body.zeroNum, name: '零分'},
            {value: data.body.badNum, name: '差'},
            {value: data.body.midNum, name: '中'},
            {value: data.body.goodNum, name: '好'}
          ]
          self.title.subtext = data.body.goodNum + '所'
          self.optionFun(numData, data.body.goodNum)
        }
      })
  },
  mounted: function () {
    var self = this
    if (this.avgScore === '' || this.avgScore === undefined) {
      var data = [
        {value: 100, name: '暂无'}
      ]
      self.title = {
        text: '\n\n\n\n\n暂无',
        textStyle: {
          color: '#999',
          fontSize: 14
        },
        x: 'center'
      }
      self.optionFun(data)
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/pie.vue?3368a093